import blank from '@/components/blank'
import index from './index'

export default {
  path:'/',
  component:blank,
  children:[
    {
      meta:{title:'首页',keepAlive:true},
      path:'index',
      component:index,
      name:'index',
    },
  ]
}



// WEBPACK FOOTER //
// ./src/pages/index/route.js